/**
 * Number formatters shared by the operations surfaces. Pure functions; the
 * rendering rules are documented on each one because they are deliberate
 * (a concurrency-capped campaign at ~0.03 CPS must stay legible).
 */

export function pct1(v: number): string {
  return `${(v * 100).toFixed(1)}%`;
}

export function pct0(v: number): string {
  return `${Math.round(v * 100)}%`;
}

// fmtCps renders the actual CPS: 1 decimal at/above 1 CPS, 2 decimals below so
// a concurrency-capped campaign at ~0.03 CPS stays legible, "0.0" when stalled.
export function fmtCps(v: number): string {
  if (v >= 1) return v.toFixed(1);
  if (v > 0) return v.toFixed(2);
  return '0.0';
}

// fmtCpsTarget renders the muted "/target" half. Integer targets (the common
// case, pacing a multiple of 60) show bare; otherwise 1 decimal. Empty when
// there's no configured target.
export function fmtCpsTarget(v: number): string {
  if (v <= 0) return '';
  return Number.isInteger(v) ? String(v) : v.toFixed(1);
}
